import { subPageField } from '~/mixins/subpageType'
import { logger } from '~/utils/logger'

export const state = () => ({
  list_singleURLs: {},
  list_spr: {},
  list_spree: {},
  list_aepr: {}
})

export const mutations = {
  update_list_singleURLs(state, data) {
    state.list_singleURLs = data
  },
  update_list_spr(state, data) {
    state.list_spr = data
  },
  update_list_spree(state, data) {
    state.list_spree = data
  },
  update_list_aepr(state, data) {
    state.list_aepr = data
  }
}

export const getters = {
  list_singleURLs: state => {
    return state.list_singleURLs
  },
  list_spr: state => {
    return state.list_spr
  },
  list_spree: state => {
    return state.list_spree
  },
  list_aepr: state => {
    return state.list_aepr
  }
}

export const actions = {
  async get_lists({ commit }, payload) {
    const data = payload.data
    const pageTypeField = subPageField(data.type)

    const engine = await payload.engine

    let results_singleURLs = []
    //let results_spr = []
    //let results_spree = []
    let results_aepr = []

    // in the following hypercube we use the pageTypeField as the first dimension
    // at the citywide level this one be valid, so we need to adjust the
    // the parsing code to expect one less value
    const hasValidFirstDim = pageTypeField === 'citywide' ? 0 : 1

    logger.debug(
      'pageTypeField',
      pageTypeField,
      'hasValidFirstDim',
      hasValidFirstDim
    )

    //#region singleURLs
    const hypercube_singleURLs = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: [pageTypeField]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['URL_AEPR_OperationalWalthrough']
            },
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['URL_AEPR_InstructionalWalkthrough']
            },
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['URL_CharterAuthorization']
            },
            qNullSuppression: false
          }
        ],
        qInitialDataFetch: [{ qWidth: 12, qHeight: 454 }]
      }
    }
    const hypercubeSession_singleURLs = await engine.createSessionObject(
      hypercube_singleURLs
    )

    const layout_singleURLs = await hypercubeSession_singleURLs.getLayout()
    const values_singleURLs = layout_singleURLs.qHyperCube.qDataPages[0].qMatrix

    for (let m = 0; m < values_singleURLs.length; m++) {
      const data_singleURLs = {
        operationalWalkthrough:
          values_singleURLs[m][0 + hasValidFirstDim].qText,
        instructionalWalkthrough:
          values_singleURLs[m][1 + hasValidFirstDim].qText,
        charterAuthorization: values_singleURLs[m][2 + hasValidFirstDim].qText
      }
      results_singleURLs.push(data_singleURLs)
    }

    const res_singleURLs = results_singleURLs
    commit('subpage/moreinfo/update_list_singleURLs', res_singleURLs, {
      root: true
    })

    //#region aepr
    const hypercube_aepr = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: [pageTypeField]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['SchoolYear_AEPR_PDF'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: -1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['URL_AEPR_PDF']
            },
            qNullSuppression: true
          }
        ],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    const hypercubeSession_aepr = await engine.createSessionObject(
      hypercube_aepr
    )
    const layout_aepr = await hypercubeSession_aepr.getLayout()
    const values_aepr = layout_aepr.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values_aepr.length; m++) {
      const data_aepr = {
        year: values_aepr[m][hasValidFirstDim].qText,
        url: values_aepr[m][1 + hasValidFirstDim].qText
      }
      results_aepr.push(data_aepr)
    }

    const res_aepr = results_aepr
    commit('subpage/moreinfo/update_list_aepr', res_aepr, { root: true })
  }
}
